import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpCorrectionQueuePage } from '@/features/pcmp/pages/PcmpCorrectionQueuePage';
import { pcmpCorrectionQueueSearchSchema } from '@/features/pcmp/types/pcmpCorrection.types';

export const Route = createFileRoute('/_auth/pcmp/correction/')({
  validateSearch: pcmpCorrectionQueueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Correction">
      <Suspense fallback={<PageLoader />}>
        <PcmpCorrectionQueuePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
